
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppButton, AppCard, AppFileUpload } from '@/components';
import { useBoosterItemAdd } from '@/modules/booster/model/add';
import { ROUTE_NAME_BOOSTER } from '@/modules/booster/router';

export default defineComponent({
    name: ROUTE_NAME_BOOSTER.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard, AppFileUpload },
    setup() {
        const { v$, model, actions, Options } = useBoosterItemAdd();

        return { v$, model, actions, Options };
    }
});
